var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 0.390625H0.0507812V19.9686H33.6108V0.390625Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_27828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 0.390625H0.0507812V19.9686H33.6108V0.390625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_27828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93164 0.390625L15.7206 6.91364H33.6106V0.390625H5.93164Z",
    fill: "#D03033"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_27828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 0.390625H0.0507812V19.9686H33.6108V0.390625Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_27828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6787 8.21906H33.6107V6.91406H15.7207L17.6787 8.21906Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_27828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 0.390625H0.0507812V19.9686H33.6108V0.390625Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_27828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7207 13.4447H33.6107V12.1367H17.6787L15.7207 13.4447Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_27828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 0.390625H0.0507812V19.9686H33.6108V0.390625Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_27828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7206 13.4443L5.93164 19.9683H33.6106V13.4443H15.7206Z",
    fill: "#1F189B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_27828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 0.390625H0.0507812V19.9686H33.6108V0.390625Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_27828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 6.91357H3.95479L0.0507812 4.30859V6.91357Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_27828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 0.390625H0.0507812V19.9686H33.6108V0.390625Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_27828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 6.91406V13.4451H3.95479L8.8508 10.1761L3.95479 6.91406H0.0507812Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_27828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 0.390625H0.0507812V19.9686H33.6108V0.390625Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_27828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 13.4443V16.0463L3.95479 13.4443H0.0507812Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_27828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 0.390625H0.0507812V19.9686H33.6108V0.390625Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_27828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 4.30823L8.8508 10.1752L0.0507812 16.0462V17.6122L11.2038 10.1752L0.0507812 2.74121V4.30823Z",
    fill: "#F2B126"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_27828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 0.390625H0.0507812V19.9686H33.6108V0.390625Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_27828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 0.390625V2.74164L11.2038 10.1757L0.0507812 17.6126V19.9686H3.57878L15.3258 12.1367H33.6108V8.21863H15.3258L3.57878 0.390625H0.0507812Z",
    fill: "#32784C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/SOUTH_AFRICA.43adbce792a9e463e8acaad2fe065be5.svg";
export { ForwardRef as ReactComponent };